import React, {useMemo} from 'react'
import {downloadCSVFiles, getDateWithTimeString} from '@/helpers/shadcn/utils'
import {useDataTable} from '@/hooks/useDataTable-hook'
import {GetFormattedActivityData} from '@/models/ActivityListModel'
import {getActivityCsvFile, handleGetActivity} from '@/services/activities'
import {ActivitiesColConfig} from '@/services/MockData/Activity/ActivitiesColConfig'
import {useQueries} from '@tanstack/react-query'

export const useActivites = () => {
  const {setPageIndex, setSortingObj, setSearchArry, pageIndex, sortingObj, searchArr, handleResetAll} = useDataTable()
  const queryParams = useMemo(() => {
    const params = new URLSearchParams()

    // Add sorting parameters if available
    if (sortingObj?.column) {
      params.append('sortBy', sortingObj.column)
      params.append('order', sortingObj.direction)
    }

    // Add pagination parameters
    params.append('pageSize', 10)
    params.append('page', pageIndex || 0)

    // Add search parameters if available
    // if (searchArr?.length > 0) {
    //   searchArr.forEach(searchObj => {
    //     params.append(searchObj.field, searchObj.value)
    //   })
    // }

    return params.toString()
  }, [sortingObj?.column, sortingObj?.direction, pageIndex])

  const [activitiesResults] = useQueries({
    queries: [
      {
        queryKey: ['GET_ACTIVITY', queryParams, searchArr],
        queryFn: () => handleGetActivity(queryParams, searchArr),
      },
    ],
  })

  const onDownloadBtnClick = async selectedIds => {
    const body = {
      ids: selectedIds,
      filters: searchArr,
    }

    const data = await getActivityCsvFile(queryParams,body)
    const fileName = `Activity_${getDateWithTimeString()}`
    downloadCSVFiles(data, fileName)
  }

  // Sync sorting state from API response
  const resultsData = useMemo(() => activitiesResults?.data || {}, [activitiesResults?.data])

  // Extract sortBy and order from API response and sync with sortingObj
  React.useEffect(() => {
    if (resultsData && resultsData.sortBy && resultsData.order) {
      // Only update if different to avoid infinite loop
      if (resultsData.sortBy !== sortingObj?.column || resultsData.order !== sortingObj?.direction) {
        setSortingObj({column: resultsData.sortBy, direction: resultsData.order})
      }
    }
  }, [resultsData, sortingObj, setSortingObj])

  const activityListData = useMemo(() => GetFormattedActivityData(resultsData), [resultsData])

  return {
    activityListData,
    activityLColConfigData: ActivitiesColConfig,
    pageIndex,
    setPageIndex,
    setSortingObj,
    sortingObj,
    setSearchArry,
    onDownloadBtnClick,
    handleResetAll,
  }
}
